import {
  GET_VEHICLES_SUCCESS,
  GET_VEHICLES_FAILURE,
  SET_VEHICLES_LOADING,
  GET_VEHICLES_BY_VIN,
  GET_VEHICLES_BY_VIN_SUCCESS,
  GET_VEHICLES_BY_VIN_FAILURE,
  GET_FEETYPES,
  GET_FEETYPES_SUCCESS,
  GET_FEETYPES_FAILURE,
  GET_POPULAR_CARS,
  GET_POPULAR_CARS_SUCCESS,
  GET_POPULAR_CARS_FAILURE,
  GET_TOP_DEAL_CARS,
  GET_TOP_DEAL_CARS_SUCCESS,
  GET_TOP_DEAL_CARS_FAILURE,
  VehicleActionTypes,
  CarState,
} from "../types/vehicleTypes";

const initialState: CarState = {
  feeTypes: [],
  popularCars: [],
  cars: [],
  carDetail: [],
  loading: false,
  error: null,
  totalPages: null,
  currentPage: null,
  totalVehicles: null,
  perPage: null,
  topDealCars: [],
};

export const vehicleReducer = (
  state = initialState,
  action: VehicleActionTypes
): CarState => {
  switch (action.type) {
    case SET_VEHICLES_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_VEHICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        cars: action.payload.data || [], // Ensure cars is always an array
        error: null,
        totalPages: action.payload.meta.total_pages,
        currentPage: action.payload.meta.current_page,
        totalVehicles: action.payload.meta.total_vehicles,
        perPage: action.payload.meta.per_page,
      };

    case GET_VEHICLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_VEHICLES_BY_VIN:
      return {
        ...state,
        loading: true,
        error: null,
        carDetail: [],
      };

    case GET_VEHICLES_BY_VIN_SUCCESS: {
      return {
        ...state,
        loading: false,
        carDetail: action.payload.data || [],
        error: null,
      };
    }

    case GET_VEHICLES_BY_VIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_FEETYPES:
      return {
        ...state,
        loading: true,
        error: null,
        feeTypes: [],
      };

    case GET_FEETYPES_SUCCESS: {
      return {
        ...state,
        loading: false,
        feeTypes: action.payload.data || [],
        error: null,
      };
    }

    case GET_FEETYPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_POPULAR_CARS:
      return {
        ...state,
        loading: true,
        error: null,
        popularCars: [],
      };

    case GET_POPULAR_CARS_SUCCESS: {
      return {
        ...state,
        loading: false,
        popularCars: action.payload.data || [],
        error: null,
      };
    }

    case GET_POPULAR_CARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_TOP_DEAL_CARS:
      return {
        ...state,
        loading: true,
        error: null,
        topDealCars: [],
      };

    case GET_TOP_DEAL_CARS_SUCCESS: {
      return {
        ...state,
        loading: false,
        topDealCars: action.payload.data || [],
        error: null,
      };
    }

    case GET_TOP_DEAL_CARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
